import React from 'react';
import styled from 'styled-components';
import { useRouter } from 'next/router';
import useTranslation from '@src/hooks/useTranslation';

import { WeakWifiIcon } from '@src/components/common/icon';
import Button from '@src/components/common/button';

const ErrorWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 20px;
	margin-top: 80px;
	text-align: center;

	@media ${props => props.theme.device.mobile} {
		position: relative;
		top: 52px; // Header height
		margin-top: 20px;
	}
`;

const StyledWeakWifiIcon = styled(WeakWifiIcon)`
	@media ${props => props.theme.device.tablet} {
		width: 359px;
	}

	@media ${props => props.theme.device.smTablet} {
		width: 359px;
	}

	@media ${props => props.theme.device.mobile} {
		width: 359px;
	}
`;

const Text = styled.div`
	margin-top: 40px;
	font-size: 18px;
	font-weight: 400;
	color: #101010;
`;

const StyledButton = styled(Button)`
	padding: 10px 20px;
	margin-top: 32px;

	@media ${props => props.theme.device.mobile} {
		width: 100%;
	}
`;

const BackLink = styled.a`
	margin-top: 12px;
	color: ${props => props.theme.colors.primary};

	@media ${props => props.theme.device.mobile} {
		margin-top: 16px;
	}
`;

const ErrorPage = (): JSX.Element => {
	const { t } = useTranslation();
	const router = useRouter();

	const handleClick = () => { router.reload(); };

	return (
		<ErrorWrapper>
			<StyledWeakWifiIcon />
			<Text>{t('common:please_refresh_page')}</Text>
			<StyledButton handleClick={handleClick}>{t('common:refresh_page')}</StyledButton>
			<BackLink href="/">{t('common:back_to_school')}</BackLink>
		</ErrorWrapper>
	);
};

export default ErrorPage;
